import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Grid, Divider, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";

import Product1 from "../../assets/product1.png";
import Product2 from "../../assets/product2.png";
import Product3 from "../../assets/product3.png";
import Product4 from "../../assets/product4.png";
import Product5 from "../../assets/product5.png";
import Product6 from "../../assets/product6.png";
import Product7 from "../../assets/product7.png";
import Product8 from "../../assets/product8.png";
import Product9 from "../../assets/product9.png";
import Product10 from "../../assets/product10.png";
import Product11 from "../../assets/product11.png";
import Product12 from "../../assets/product12.png";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";
import { CardOutline, CubeOutline } from "react-ionicons";

const ShowcaseOrderDetails = ({ sector, order, showIcons, showReturn }) => {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const [orderDetails, setOrderDetails] = useState(null);

	console.log(order);
	useEffect(() => {
		const loadOrderDetails = () => {
			if (sector === "ecommerce") {
				return {
					orderNumber: "#1668944642893",
					orderDate: "20 Nov 22",
					products: [
						{
							name: t("orderDetails.sunsetBlueSweater"),
							price: "€18.99",
							quantity: 1,
							image: Product1,
						},
					],
					total: "€18.99",
					shipping: "€0.00",
					billingAddress: t("orderDetails.billingAddressSample"),
					shippingMethod: t("orderDetails.pickUp"),
					paymentInfo: t("orderDetails.visaEnding") + " 4242",
					status: t("orderDetails.inProgress"),
				};
			} else if (sector === "restaurant") {
				return {
					orderNumber: "#1668944642893",
					orderDate: "20 Nov 22",
					products: [
						{
							name: t("orderDetails.pepperoniPizza"),
							price: "€8.00",
							quantity: 1,
							image: ProductRestaurant1,
						},
						{
							name: t("orderDetails.cheesePizza"),
							price: "€8.00",
							quantity: 1,
							image: ProductRestaurant2,
						},
					],
					total: "€24.00",
					shipping: "€0.00",
					billingAddress: t("orderDetails.billingAddressSample"),
					shippingMethod: t("orderDetails.localDelivery"),
					paymentInfo: t("orderDetails.visaEnding") + " 4242",
					status: t("orderDetails.completed"),
				};
			}
			return {};
		};

		setOrderDetails(loadOrderDetails());
	}, [sector, t]);

	const calculateTotal = () => {
		switch (sector) {
			case "ecommerce":
				return "€44.98";
			case "restaurant":
				return "€44.98";

			default:
				return "€18";
		}
	};

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	return (
		<Box sx={{ padding: 1 }}>
			<Grid container>
				{order.value === "orderDetail2" && (
					<>
						<Grid item xs={12}>
							<Box
								sx={{
									display: "flex",
									alignItems: "flex-start",
									gap: 1,
									marginBottom: 1,
									flexDirection: "column",
								}}
							>
								<img
									src={orderDetails?.products[0].image}
									alt={orderDetails?.products[0].name}
									style={{
										width: "100%",
										height: 100,
										objectFit: "cover",
										marginRight: 1,
									}}
								/>
								<Box
									sx={{
										display: "flex",
										flex: 1,
										justifyContent: "space-between",
										width: "100%",
									}}
								>
									<Typography sx={{ fontSize: "8px" }}>
										{orderDetails?.products[0].name}
									</Typography>
									<Typography sx={{ fontSize: "8px" }}>
										{orderDetails?.products[0].quantity} x{" "}
										{orderDetails?.products[0].price}
									</Typography>
								</Box>
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flex: 1,
										width: "100%",
									}}
								>
									{orderDetails &&
										orderDetails.products.map((_, index) => (
											<Box
												key={index}
												sx={{
													width: 3,
													height: 3,
													borderRadius: "50%",
													backgroundColor: index === 0 ? "#000000" : "#ddd",
													marginX: 0.5,
												}}
											/>
										))}
								</Box>
							</Box>
						</Grid>
					</>
				)}
				<Grid item xs={12}>
					<Typography
						variant="body2"
						sx={{ fontSize: "8px", fontWeight: "bold" }}
					>
						{orderDetails?.status}
					</Typography>
					<Typography variant="body2" sx={{ fontSize: "8px" }}>
						{t("orderDetails.orderNumber")}: {orderDetails?.orderNumber}
					</Typography>
					<Typography variant="body2" sx={{ fontSize: "8px" }}>
						{t("orderDetails.orderDate")}: {orderDetails?.orderDate}
					</Typography>

					{order.value === "orderDetail1" && <Divider sx={{ my: 1 }} />}
				</Grid>
				{order.value === "orderDetail1" && (
					<>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								marginBottom: 0.5,
								textTransform: "capitalize",
							}}
						>
							{t("orderDetails.products")}
						</Typography>
						{orderDetails?.products.map((product, index) => (
							<Grid item xs={12} key={index}>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 1,
										marginBottom: 1,
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: 50,
											height: 50,
											objectFit: "cover",
											marginRight: 1,
										}}
									/>
									<Box>
										<Typography sx={{ fontSize: "8px" }}>
											{product.name}
										</Typography>
										<Typography sx={{ fontSize: "8px" }}>
											{product.quantity} x {product.price}
										</Typography>
									</Box>
								</Box>
							</Grid>
						))}
					</>
				)}
				<Grid item xs={12}>
					<Divider sx={{ my: 1 }} />
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								textTransform: "capitalize",
							}}
						>
							{t("orderDetails.products")}
						</Typography>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								textTransform: "capitalize",
							}}
						>
							{calculateTotal()}
						</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{t("orderDetails.shipping")}:
						</Typography>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								textTransform: "capitalize",
							}}
						>
							€0
						</Typography>
					</Box>

					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{t("orderDetails.total")}:
						</Typography>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								textTransform: "capitalize",
							}}
						>
							{calculateTotal()}
						</Typography>
					</Box>

					<Divider sx={{ my: 1 }} />
				</Grid>

				{showIcons ? (
					<Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<CubeOutline height="12px" width="12px" />
							<Typography
								variant="body2"
								sx={{
									fontSize: "8px",
									textTransform: "capitalize",
									fontWeight: "bold",
									textAlign: "center",
								}}
							>
								{t("orderDetails.paymentInfo")}
							</Typography>
							<Typography
								variant="body2"
								sx={{ fontSize: "8px", textAlign: "center" }}
							>
								{orderDetails?.shippingMethod}
							</Typography>
						</Box>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<CardOutline height="12px" width="12px" />
							<Typography
								variant="body2"
								sx={{
									fontSize: "8px",
									textTransform: "capitalize",
									fontWeight: "bold",
									textAlign: "center",
								}}
							>
								{t("orderDetails.shippingMethod")}
							</Typography>
							<Typography
								variant="body2"
								sx={{ fontSize: "8px", textAlign: "center" }}
							>
								{orderDetails?.paymentInfo}
							</Typography>
						</Box>
					</Box>
				) : (
					<Grid item xs={12}>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								marginBottom: 0.5,
								textTransform: "capitalize",
								fontWeight: "bold",
							}}
						>
							{t("orderDetails.billingAddress")}
						</Typography>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{orderDetails?.billingAddress}
						</Typography>
						<Divider sx={{ my: 1 }} />
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								marginBottom: 0.5,
								textTransform: "capitalize",
								fontWeight: "bold",
							}}
						>
							{t("orderDetails.shippingMethod")}
						</Typography>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{orderDetails?.shippingMethod}
						</Typography>
						<Divider sx={{ my: 1 }} />
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								marginBottom: 0.5,
								textTransform: "capitalize",
								fontWeight: "bold",
							}}
						>
							{t("orderDetails.paymentInfo")}
						</Typography>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{orderDetails?.paymentInfo}
						</Typography>
						<Divider sx={{ my: 1 }} />
					</Grid>
				)}

				{showReturn && sector === "ecommerce" && (
					<>
						<Divider sx={{ my: 1 }} />
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								textTransform: "capitalize",
								marginBottom: 1,
							}}
						>
							{t("orderDetails.returnText")}
						</Typography>{" "}
						<Button
							variant="contained"
							fullWidth
							sx={{
								color: hexToRGBA("#000000", 0.6),
								border: `1px solid ${hexToRGBA("#000000", 0.2)}`,
								backgroundColor: "#ffffff",
								"&:hover": {
									backgroundColor: "#ffffff",
								},
								fontSize: "8px",
								borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
								fontWeight: "bold",
								textTransform: "uppercase",
								height: "28px",
								width: "100%",
							}}
						>
							{t("orderDetails.returnButton")}
						</Button>
					</>
				)}
			</Grid>
		</Box>
	);
};

export default ShowcaseOrderDetails;
